import Select from './src'

Select.install = Vue => {
  Vue.component(Select.name, Select)
}

export default Select
